import React, { useEffect, useState } from "react";
import {
    Input,
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
    Form,
} from "reactstrap";
import Swal from "sweetalert2"
import { BASE_URL } from "../../utils/constants";
import axios from "axios";
const IncidentModal = (props) => {
    const isViewMode = props.IncidentId !== "";

    const [formData, setFormData] = useState({
        id: 0,
        name: "",
        description: "",
        incidentdate: "",
        driveid: "",
      
        witnesses: "",
        gradelevel: "",
        location: "",
        persontype:"",
        grade_id:""
    });



    const [file, setFile] = useState(null);


    useEffect(() => {
        setFile(null);
        if (props.Modal && props.IncidentId != "") {

            axios.get(`${BASE_URL}/student/incidents/getincident.php?id=${props.IncidentId}`).then((res) => {
                setFormData(res.data.data)
            })
        }else {
            setFormData({
                id: 0,
                name: "",
                description: "",
                incidentdate: "",
                driveid: "",
              
                witnesses: "",
                gradelevel: "",
                location: "",
                persontype:"",
                grade_id:""
            })
        }
    }, [props.Modal, props.IncidentId])




    const submitHandler = (e) => {
        e.preventDefault();
        Swal.showLoading();
        let SendData = new FormData();
        SendData.append("id", formData.id);
        SendData.append("file", file);
        SendData.append("description", formData.description);
        SendData.append("name", formData.name);
        SendData.append("location", formData.location);
        SendData.append("witnesses", formData.witnesses);
        SendData.append("incidentdate", formData.incidentdate);
        SendData.append("persontype", formData.persontype);
        SendData.append("grade_id", formData.grade_id);


        axios
            .post(`${BASE_URL}/student/incidents/addincident.php`, SendData, {
                headers: { "content-type": "multipart/form-data" },
            })
            .then((res) => {
                Swal.fire("Saved Successfully", "", "success");
                props.updateIncidents(res.data.data)
                props.setModal(false)
              
            })
            .catch((e) => {
                let ee = e;

                Swal.fire(ee?.response?.data.msg || "Failed to upload", "", "error");
            })
          
    };
    const handleSelectFile = (e) => {
        if (e.target.files === null) return;
        const selectedFile = e.target.files[0];
        setFile(selectedFile);

        if (e.target.files[0]?.type?.match("image") === null) {
            getThumbnail(selectedFile);
        }
    };

    // get thumbnail
    function getThumbnail(file) {
        var fileReader = new FileReader();
        if (file.type.match("image")) {
            // fileReader.onload = function () {
            //   $("#blah").attr("src", fileReader.result);
            // };
            // fileReader.readAsDataURL(file);
        } else {
            fileReader.onload = function () {
                var blob = new Blob([fileReader.result], {
                    type: file.type,
                });
                var url = URL.createObjectURL(blob);
                var video = document.createElement("video");
                var timeupdate = function () {
                    if (snapImage()) {
                        video.removeEventListener("timeupdate", timeupdate);
                        video.pause();
                    }
                };
                video.addEventListener("loadeddata", function () {
                    if (snapImage()) {
                        video.removeEventListener("timeupdate", timeupdate);
                    }
                });
                var snapImage = function () {
                    var canvas = document.createElement("canvas");
                    canvas.width = video.videoWidth;
                    canvas.height = video.videoHeight;
                    canvas
                        .getContext("2d")
                        .drawImage(video, 0, 0, canvas.width, canvas.height);
                    var image = canvas.toDataURL();
                    var success = image.length > 100000;
                    // Thumbnail --- image  base64
                    if (success) {
                        // $("#video_image").val(image);
                        setFormData((prevState) => ({
                            ...prevState,
                            video_image: image,
                        }));
                    }
                    return success;
                };
                video.addEventListener("timeupdate", timeupdate);
                video.preload = "metadata";
                video.src = url;
                // Load video in Safari / IE11
                video.muted = true;
                video.playsInline = true;
                video.play();
            };
            fileReader.readAsArrayBuffer(file);
        }
    }




    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setFormData(prevState => ({ ...prevState, [name]: value }));
    };

    const getRoleLabel = (value) => {
        if (value === "s") return "Student";
        if (value === "t") return "Teacher";
        return "-";
    };

    const getGradeLabel = () => {
        if (formData.gradelevel) return formData.gradelevel;
        const grade = props.Grades?.find((grade) => String(grade.id) === String(formData.grade_id));
        return grade?.grade || "-";
    };

    const formatIncidentDate = (value) => {
        if (!value) return "-";
        return value.replace("T", " ");
    };

    const DetailItem = ({ label, value, wide = false }) => (
        <div className={wide ? "col-sm-12" : "col-sm-12 col-lg-6"}>
            <div className="mb-3">
                <div className="text-secondary fw-bold">{label}</div>
                <div
                    className="border rounded bg-light p-2"
                    style={{ minHeight: "38px", whiteSpace: "pre-wrap" }}
                >
                    {value || "-"}
                </div>
            </div>
        </div>
    );

    const renderViewContent = () => (
        <div className="row">
            <DetailItem label="Person in concern name" value={formData.name} />
            <DetailItem label="Role" value={getRoleLabel(formData.persontype)} />
            {formData.persontype === "s" && (
                <DetailItem label="Grade level" value={getGradeLabel()} />
            )}
            <DetailItem label="Date" value={formatIncidentDate(formData.incidentdate)} />
            <DetailItem label="Location" value={formData.location} />
            <DetailItem label="Description" value={formData.description} wide />
            <DetailItem label="Witnesses" value={formData.witnesses} wide />
            {formData.driveid && (
                <div className="col-sm-12">
                    <div className="text-secondary fw-bold mb-2">Uploaded image</div>
                    <img
                        className="w-100 rounded border"
                        src={formData.driveid}
                        alt="Incident attachment"
                        style={{ maxHeight: "360px", objectFit: "contain" }}
                    />
                </div>
            )}
        </div>
    );

    const renderFormContent = () => (
        <Form onSubmit={submitHandler}>
            <div className="row">

                <div className="col-sm-12 col-lg-6">
                    <label>Person in concern name </label>{" "}
                    <span style={{ color: "red" }}>*</span>
                    <Input
                        style={{ borderColor: "black" }}
                        onChange={handleChange}
                        name="name"
                        type="text"
                        value={formData.name}

                    ></Input>
                </div>
                <div className="col-sm-12 col-lg-6">
                    <div className="m-0 col-sm-12 col-lg-6 form-group">
                        <div>
                            <label className="text-secondary">Role : </label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" onClick={handleChange} required name="persontype" id="student" value="s" checked={formData.persontype == "s" ? true : false} />
                            <label className="form-check-label" htmlFor="student">Student</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" onClick={handleChange} required name="persontype" id="teacher" value="t" checked={formData.persontype == "t" ? true : false} />
                            <label className="form-check-label" htmlFor="teacher">Teacher</label>
                        </div>
                    </div>
                </div>
                {formData.persontype == "s" && (
                    <div className="col-sm-12 col-lg-6">
                        <div>
                            <label className="text-secondary">Grade level : </label>
                            <select className="form-control" name="grade_id" value={formData.grade_id} onChange={handleChange}>

                                <option value="">Select Grade</option>
                                {props.Grades?.map((grade) => {
                                    return <option key={grade.id} value={grade.id}>{grade.grade}</option>
                                })}

                            </select>
                        </div>
                    </div>
                )}
                <div className="m-0 col-sm-12 col-lg-6 form-group" id="fullday">
                    <label className="text-secondary testcolor">Date : </label>

                    <input name="incidentdate" type="datetime-local" className="form-control test" autoComplete="off"
                        onChange={handleChange}

                        value={formData.incidentdate} />
                </div>

                <div className="col-sm-12 col-lg-6">
                    <div>
                        <label className="text-secondary">Location : </label>
                        <input type="text" className="form-control" name="location" onChange={handleChange} value={formData.location} />
                    </div>

                </div>
                <div className="col-sm-12 ">
                    <label>Description</label>{" "}
                    <span style={{ color: "red" }}>*</span>
                    <textarea
                        onChange={handleChange}
                        name="description"
                        rows="4"
                        value={formData.description}

                        className="col-12"
                    ></textarea>
                </div>
                <div className="col-sm-12 ">
                    <label>Witnesses</label>{" "}
                    <span style={{ color: "red" }}>*</span>
                    <textarea
                        onChange={handleChange}

                        name="witnesses"
                        rows={4}
                        value={formData.witnesses}

                        className="col-12"
                    ></textarea>
                </div>
                <div className="col-sm-12 ">
                    <Input className="d-none" id="video_image"></Input>
                    <label>Upload Image </label>
                    <span style={{ color: "red" }}>*</span>

                    <Input
                        onChange={handleSelectFile}
                        name="file"
                        type="file"

                    ></Input>
                </div>
                {formData.driveid && <img
                    className="col-12"
                    src={formData.driveid}
                    alt="Incident attachment"
                ></img>}
            </div>


            <div style={{ display: "flex", justifyContent: "center" }}>
                <button
                    style={{ width: "50%" }}
                    className="btn btn-primary m-3"
                    type="submit"
                    disabled={


                        formData.name === "" ||
                        formData.description === ""
                    }
                >
                    Submit
                </button>
            </div>
        </Form>
    );




    return (
        <>
            <Modal
                isOpen={props.Modal}
                className="modal-md"
                style={{ width: "50%", height: "50%", top: "20" }}
            >
                <ModalHeader className="bg-info fw-bolder">
                    {isViewMode ? "Incident details" : "Report incident"}
                </ModalHeader>
                <ModalBody>
                    {isViewMode ? renderViewContent() : renderFormContent()}
                </ModalBody>
                <ModalFooter>
                    <button
                        className="btn btn-secondary"
                        onClick={() => props.setModal(false)}
                    >
                        Close
                    </button>
                </ModalFooter>
            </Modal>


        </>
    )
}


export default IncidentModal
